<!-- webView -->
<div class="container-fluid webView">
    <div style="display: inline;block-size: 10%;">
        <!--Header-->
        <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite" style="padding-right: 0px;padding: 15px;">
            <div class="col-md-3 col-sm-6 lblHeader newHeader" style="display: inline-block;padding: 0px;">
                <h2 style="font-size: 25px;"> Material Requirement</h2>
            </div>
            <div class="col-md-9 col-sm-6" style="display: inline-block; padding: 0px;text-align: right;">
                <!-- <div *ngIf="selectedItems.length > 10" class="btn-darkBlue brdrRadius3" style="height: 31px; font-size: 13px; line-height: 25px;" (click)="calculateRequirement()">
                    Calculate Requirement
                </div> -->
                <span class="search" *ngIf="dataSource.data.length > 0">
                    <span class="fa fa-search"></span>
                    <input class="form-control brdrColor brdrRadius3" ng-model="search.term" placeholder="Search" matInput
                      (keyup)="applyFilter($event)" #input
                      style="text-align: left;display: inline-block; padding-left: 35px !important; font-size: 13px; box-shadow: none; width: 30% !important; height: 33px !important;"
                      type="text">
                </span>
                <span class="btn orangeButton" (click)="openItemSelect(selectItem)"
                    style="margin-left: 10px;font-size: 13px !important; color:#fff; border-radius: 3px;">
                    <i class="zmdi zmdi-plus" aria-hidden="true" style="position: relative; top: 0px; font-size: 16px"></i>
                    <span style="margin-left: 7px;">{{selectedItems.length > 0 ? 'Select More Items' : 'Select Items'}}</span>
                </span>
                <span *ngIf="exportToExcel.length > 0" (click)="exportToExcelActivities();" class="darkBlueButton brdrRadius3" style="margin-left: 10px; cursor: pointer; line-height: 20px; height: 31px;" title="Export to Excel">
                    <span>
                      <i aria-hidden="true" style="font-size: 14px;" class="fa fa-file-excel-o"></i>
                    </span>
                </span>
                <span (click)="refresh()" class="darkBlueButton" style="margin-left: 10px; cursor: pointer; line-height: 20px; height: 31px;" title="Refresh">
                    <i aria-hidden="true" style="font-size: 14px;" class="fa fa-refresh"></i>
                </span>
                <div style="display: inline-block; padding: 0px;" title="Back to Account Dashboard">
                    <span class="btn-darkBlue brdrRadius3"
                        style="font-size: 13px; display: inline-block; padding: 4px 12px 5px; margin-left: 10px; height: 31px;"
                        (click)="backBtn()">
                        <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
                    </span>
                </div>
            </div>
        </div>
    </div>

    <!-- Selected Items Table -->
    <div class="col-md-6 col-6 col-sm-6 pad0 bgWhite" style="padding: 0px 15px 15px;"
        *ngIf="selectedItems.length > 0 && dataSource.data.length == 0" >
        <div class="col-md-6 col-sm-6 newHeader" style="display: inline-block; padding: 0px;">
            <h4 style="font-size: 20px;"> Products</h4>
        </div>
        <table class="table ngTable bzMatTbl shadow brdrRadius3" style="width: 100%; margin-bottom: 10px; background-color: white;">
            <thead>
                <tr>
                    <th style="width: 50%; padding-left: 10px; font-size: 13px; border-top: none;">Item</th>
                    <th style="width: 25%; font-size: 13px;">Qty</th>
                    <th style="width: 25%; padding-left: 15px; font-size: 13px;">Unit</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of selectedItems; let l = last; let i = index">
                    <td style="padding-left: 10px; font-size: 12px; {{l ? 'border-bottom-left-radius: 10px;' : ''}}">
                        <div>{{item.ItemName}}</div>
                    </td>
                    <td>
                        <span class="wid60" style="display: inline-block; width: 90%; font-size: 12px;">
                            <input type="text" 
                                class="form-control"
                                [(ngModel)]="item.ReqdQty"
                                (change)="updateQuantity(item)"
                                (keyup)="numbersOnly(item)"
                                [tabindex]="i + 1"
                                (keydown.tab)="$event.target.blur()"
                                style="text-align: right; height: 25px; position: relative; bottom: 1px; width: 100px !important; background-color: inherit;">
                        </span>
                    </td>
                    <td style="padding-left: 15px; font-size: 12px;">{{item.SKU}}</td>
                    <td style="width: 20px; cursor: pointer; {{l ? 'border-bottom-right-radius: 10px;' : ''}}">
                        <button class="lableBtnGray brdrRadius3" 
                            (click)="removeItem(i)" 
                            [tabindex]="selectedItems.length + i + 1"
                            style="border-radius: 15px; padding: 3px 9px;">
                            <i class="fa fa-trash"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Calculate Button -->
        <div class="col-md-12 text-right" style="margin-top: 15px; padding: 0;">
            <div class="btn-darkBlue brdrRadius3" style="height: 30px; font-size: 13px; line-height: 24px;" (click)="calculateRequirement()">
                Calculate Requirement
            </div>
        </div>
    </div>

    <!-- Selected Items Table View Only -->
    <div class="col-md-6 col-6 col-sm-6 pad0 bgWhite" style="padding: 0px 15px 15px;"
        *ngIf="selectedItems.length > 0 && dataSource.data.length > 0">
        <div class="col-md-6 col-sm-6 newHeader" style="display: inline-block; padding: 0px;">
            <h4 style="font-size: 20px;"> Products</h4>
        </div>
        <table class="table ngTable bzMatTbl shadow brdrRadius3" style="width: 100%; margin-bottom: 10px; background-color: white;">
            <thead>
                <tr>
                    <th style="width: 50%; padding-left: 10px; font-size: 13px; border-top: none;">Item</th>
                    <th style="width: 25%; font-size: 13px;">Qty</th>
                    <th style="width: 25%; padding-left: 15px; font-size: 13px;">Unit</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of selectedItems; let l = last; let i = index">
                    <td style="padding-left: 10px; font-size: 12px; {{l ? 'border-bottom-left-radius: 10px;' : ''}}">
                        <div>{{item.ItemName}}</div>
                    </td>
                    <td>{{item.ReqdQty}}</td>
                    <td style="padding-left: 15px; font-size: 12px;">{{item.SKU}}</td>
                </tr>
            </tbody>
        </table>

        <!-- Calculate Button -->
        <div class="col-md-12 text-right" style="margin-top: 15px; padding: 0;">
            <div class="btn-darkBlue brdrRadius3" style="height: 30px; font-size: 13px; line-height: 24px;" (click)="changeTarget()">
                Change Target
            </div>
        </div>
    </div>

    <!-- No Items Message -->
    <div *ngIf="selectedItems.length === 0">
        <div class="nrf  brdrRadius3" (click)="openItemSelect(selectItem);" style="margin: 15px; font-size: 13px; cursor: pointer;">
            Please select items to calculate material requirements.
        </div>
    </div>

    <!--Data Table-->
    <div class="col-md-12 col-12 col-sm-12 pad0" style="padding: 0px 15px 15px;">
        <div  style="text-overflow: ellipsis; white-space: nowrap;"
            *ngIf="dataSource.data.length > 0" #mtlAviaTable>
            <div class="col-md-6 col-sm-6 newHeader" style="display: inline-block;padding: 0px;">
                <h4 style="font-size: 20px;"> Materials</h4>
            </div>
            <div class="col-md-12 col-12 col-sm-12 pad0 bzMatTbl shadow brdrRadius3" style="width: {{showItemsTags ? '100%' : '100%'}};">
            <table mat-table [dataSource]="dataSource" matSort style="border-radius: 3px;">
            
                <ng-container matColumnDef="Material" style="cursor: pointer;">
            
                <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header>
                    <label>Material</label>
                </th>
                <td mat-cell *matCellDef="let element" style="width: 25% !important; padding-left: 24px;">
                    <div style="display: flex; align-items: center; max-width: 100%; padding-right: 8px;">
                        <div style="white-space: break-word; overflow: hidden; text-overflow: ellipsis; word-break: break-all; white-space: normal;">
                            {{element.Material}}
                        </div>
                        <span *ngIf="element.BOM.length > 0" class="addIcon" (click)="expandItem(element)"
                                style="display: inline-flex; align-items: center; justify-content: center; min-width: 30px; height: 30px; cursor: pointer; margin-left: 5px;">
                            <i class="fa fa-plus" style="vertical-align: middle;"></i>
                        </span>
                    </div>
                </td>
                </ng-container>
            
                <ng-container matColumnDef="requiredQty">
                    <th class="header header-Table" style="cursor: pointer; padding-left: 3% !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
                    <label>Required Qty</label>
                    </th>
                    <td mat-cell *matCellDef="let element" style="text-align: right; width: 7%; font-weight: bold;"> {{element.requiredQty ? element.requiredQty : '-'}} </td>
                </ng-container>

                <ng-container matColumnDef="pndgSOQty">
                    <th class="header header-Table" style="cursor: pointer; padding-left: 3% !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
                    <label>Orders</label>
                    </th>
                    <td mat-cell *matCellDef="let element" style="text-align: right; width: 7%;"> {{element.pndgSOQty}} </td>
                </ng-container>

                <ng-container matColumnDef="planQty">
                    <th class="header header-Table" style="cursor: pointer; padding-left: 3% !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
                    <label>Planned Use</label>
                    </th>
                    <td mat-cell *matCellDef="let element" style="text-align: right; width: 7%;"> {{element.planQty}} </td>
                </ng-container>

                <ng-container matColumnDef="totalNeedQty">
                    <th class="header header-Table" style="cursor: pointer; padding-left: 3% !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
                    <label>Total Need</label>
                    </th>
                    <td mat-cell *matCellDef="let element" style="text-align: right; width: 7%;"> {{element.totalNeedQty}} </td>
                </ng-container>

                <ng-container matColumnDef="stockQty">
                    <th class="header header-Table" style="cursor: pointer; padding-left: 3% !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
                    <label>Stock</label>
                    </th>
                    <td mat-cell *matCellDef="let element" style="text-align: right; width: 7%; font-weight: bold;"> {{element.stockQty}} </td>
                </ng-container>

                <ng-container matColumnDef="poQty">
                    <th class="header header-Table" style="cursor: pointer; padding-left: 3% !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
                    <label>PO</label>
                    </th>
                    <td mat-cell *matCellDef="let element" style="text-align: right; width: 7%;"> {{element.poQty}} </td>
                </ng-container>

                <ng-container matColumnDef="pndgPrdJobQty">
                    <th class="header header-Table" style="cursor: pointer; padding-left: 3% !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
                    <label>WIP</label>
                    </th>
                    <td mat-cell *matCellDef="let element" style="text-align: right; width: 7%;"> {{element.pndgPrdJobQty}} </td>
                </ng-container>

                <ng-container matColumnDef="shortFallQty">
                    <th class="header header-Table" style="cursor: pointer; padding-left: 3% !important;" mat-header-cell *matHeaderCellDef mat-sort-header>
                    <label>Shortfall</label>
                    </th>
                    <td mat-cell *matCellDef="let element" style="text-align: right; width: 7%; font-weight: bold;"> {{element.shortFallQty}} </td>
                </ng-container>
            
                <ng-container matColumnDef="Unit">
                    <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                    <label> Unit </label>
                    </th>
                    <td mat-cell *matCellDef="let element" style="width: 7%;"> {{element.Unit}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns;"></tr>
            </table>
            <!-- Angular 8 pagination -->
            <mat-paginator [pageSizeOptions]="[10,20,30,40,50]" showFirstLastButtons style="border-radius: 3px;">
            </mat-paginator>
            </div>
        </div>
    </div>

   <!-- <div *ngIf="dataSource.data.length == 0 && selectedItems.length > 0">
     <div style="margin:15px" class="nrf brdrRadius3">No records found.</div>
   </div> -->
</div>

<ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">
</ngx-spinner>

<!-- Item Selection Modal Template -->
<ng-template #selectItem let-modal>
    <button id="closeModalButton" data-toggle="modal" [hidden]="true"       
    data-target="#myModal" class="btn btn-default" (click)="modal.close()">Close</button>
</ng-template>